import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal, ImageCarousel } from '../../components';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionImages = props => {
  const {
    title,
    listing,
    isOwnListing,
    editParams,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
  } = props;

  const images = listing.images || [];
  const listingId = listing && listing.id && listing.id.uuid ? listing.id.uuid : 'listing';
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    setSelectedImageIndex(0);
  }, [listingId, images.length]);

  const hasImages = images.length > 0;
  const firstImage = hasImages ? images[0] : null;
  const selectedImage =
    hasImages && images[selectedImageIndex] ? images[selectedImageIndex] : firstImage;
  const showImageSelector = images.length > 1;

  // Action bar is wrapped with a div that prevents the click events
  // to the parent that would otherwise open the image carousel
  const actionBar = listing.id ? (
    <div onClick={e => e.stopPropagation()}>
      <ActionBarMaybe isOwnListing={isOwnListing} listing={listing} editParams={editParams} />
    </div>
  ) : null;

  const viewPhotosButton = hasImages ? (
    <button type="button" className={css.thumbnailViewAllButton} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: images.length }}
      />
    </button>
  ) : null;

  return (
    <div className={css.sectionImages}>
      <div className={css.threeToTwoWrapper}>
        <div className={css.aspectWrapper} onClick={handleViewPhotosClick}>
          {actionBar}
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={title}
            image={selectedImage}
            variants={[
              'landscape-crop',
              'landscape-crop2x',
              'landscape-crop4x',
              'landscape-crop6x',
            ]}
          />
        </div>
      </div>
      {showImageSelector ? (
        <div className={css.thumbnailRail}>
          <div className={css.thumbnailScroller}>
            {images.map((image, index) => {
              const imageId = image && image.id && image.id.uuid ? image.id.uuid : `image-${index}`;
              const isSelected = index === selectedImageIndex;

              return (
                <button
                  key={imageId}
                  type="button"
                  className={`${css.thumbnailButton} ${isSelected ? css.thumbnailButtonActive : ''}`}
                  onClick={event => {
                    event.stopPropagation();
                    setSelectedImageIndex(index);
                  }}
                  aria-pressed={isSelected}
                  aria-label={`${title} ${index + 1}`}
                >
                  <ResponsiveImage
                    rootClassName={css.thumbnailImage}
                    alt={`${title} ${index + 1}`}
                    image={image}
                    variants={['landscape-crop', 'landscape-crop2x']}
                  />
                </button>
              );
            })}
            {viewPhotosButton}
          </div>
        </div>
      ) : null}
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </div>
  );
};

export default SectionImages;
